import { request } from "../utils/config"

export interface MobileConfigItem {
  sectionCode: string
  enabled: boolean
  inTabBar: boolean
  sortOrder: number
  hiddenFields: string[]
  pageSize: number
}

const auth = () => ({
  Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
})

/** Mobil ilova sozlamalari — ilova ochilishida bir marta olinadi */
export const GET_MOBILE_CONFIG = async (): Promise<MobileConfigItem[]> => {
  const res = await request({ url: `MobileConfig`, headers: auth(), silent: true })
  return res.data || []
}

export const SAVE_MOBILE_CONFIG = async (
  items: MobileConfigItem[]
): Promise<MobileConfigItem[]> => {
  const res = await request({
    url: `MobileConfig`,
    method: "PUT",
    data: items,
    headers: auth(),
  })
  return res.data || []
}

/**
 * Ro'yxat ma'lumoti. Manzil bo'lim ta'rifidan keladi, shuning uchun
 * har bir bo'limga alohida so'rov fayli yozilmaydi.
 */
export const GET_MOBILE_LIST = async (params: {
  url: string
  pageNumber: number
  pageSize: number
  searchText?: string
  extra?: Record<string, any>
}) => {
  const res = await request({
    url: params.url,
    params: {
      PageNumber: params.pageNumber,
      PageSize: params.pageSize,
      ...(params.searchText ? { SearchText: params.searchText } : {}),
      ...(params.extra || {}),
    },
    headers: auth(),
  })
  return res.data
}
